import React from "react";

const MergeSummaryPanel = ({
  mergePreview,
  conflictResolutions,
  mergeReason,
  onMergeReasonChange,
  confirmChecked,
  onConfirmCheckedChange,
}) => {
  const getResolutionCount = () => {
    if (!conflictResolutions) return 0;
    return Object.keys(conflictResolutions).length;
  };

  return (
    <div>
      <h6 className="my-2">Review Merge Summary</h6>

      {/* Merge Preview */}
      {mergePreview && (
        <div className="row g-3 mb-4">
          <div className="col-md-6">
            <div className="merge-refined-card merge-refined-card-primary">
              <div className="merge-refined-card-head">Primary Patient (Keeping)</div>
              <div className="merge-refined-card-body">
                <div className="merge-refined-name">{mergePreview.primary_patient?.first_name} {mergePreview.primary_patient?.last_name}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">DOB:</span> {mergePreview.primary_patient?.dob || '—'}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">Phone:</span> {mergePreview.primary_patient?.phone || '—'}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">Visits:</span> {mergePreview.primary_visits_count ?? '—'}</div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="merge-refined-card merge-refined-card-secondary">
              <div className="merge-refined-card-head">Secondary Patient (Merging From)</div>
              <div className="merge-refined-card-body">
                <div className="merge-refined-name">{mergePreview.secondary_patient?.first_name} {mergePreview.secondary_patient?.last_name}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">DOB:</span> {mergePreview.secondary_patient?.dob || '—'}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">Phone:</span> {mergePreview.secondary_patient?.phone || '—'}</div>
                <div className="merge-refined-meta"><span className="merge-refined-label">Visits:</span> {mergePreview.secondary_visits_count ?? '—'}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Merge Statistics */}
      <div className="merge-refined-section mb-4">
        <div className="card border-0">
          <div className="card-header sh_accordionheader"><h6 className="mb-0">Merge Statistics</h6></div>
          <div className="card-body p-2">
            <div className="row g-3">
              <div className="col-4">
                <div className="merge-refined-stat">
                  <span className="merge-refined-stat-value">{mergePreview?.total_visits_after_merge || 0}</span>
                  <span className="merge-refined-stat-label">Total Visits After Merge</span>
                </div>
              </div>
              <div className="col-4">
                <div className="merge-refined-stat">
                  <span className="merge-refined-stat-value">{getResolutionCount()}</span>
                  <span className="merge-refined-stat-label">Conflicts Resolved</span>
                </div>
              </div>
              <div className="col-4">
                <div className="merge-refined-stat">
                  <span className="merge-refined-stat-value">{mergePreview?.secondary_visits_count || 0}</span>
                  <span className="merge-refined-stat-label">Visits to Transfer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conflict Resolutions Summary */}
      {getResolutionCount() > 0 && (
        <div className="merge-refined-section mb-4">
          <div className="card border-0">
            <div className="card-header sh_accordionheader"><h6 className="mb-0">Conflict Resolutions Applied</h6></div>
            <div className="card-body p-2">
              <div className="merge-refined-table-wrap">
                <table className="table sh_tablenew" id="mergeConflictTable">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Resolution</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(conflictResolutions || {}).map((key) => {
                    const resolution = conflictResolutions[key];
                    return (
                      <tr key={key}>
                        <td>{key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}</td>
                        <td>
                          {resolution === 'primary' && <span className="merge-refined-pill">Keep Primary</span>}
                          {resolution === 'secondary' && <span className="merge-refined-pill">Use Secondary</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Merge Reason */}
      <div className="merge-refined-section mb-4">
        <div className="card border-0">
          <div className="card-header sh_accordionheader"><h6 className="mb-0">Merge Reason (Optional)</h6></div>
          <div className="card-body">
            <textarea
              className="form-control merge-refined-textarea"
              rows="2"
              placeholder="Enter reason for merging these charts..."
              value={mergeReason || ''}
              onChange={(e) => onMergeReasonChange(e.target.value)}
              maxLength={1000}
            />
          </div>
        </div>
      </div>

      {/* Warning Messages */}
      <div className="merge-refined-alert" role="alert">
        <strong>Important:</strong>
        <ul className="mb-0 ps-3">
          <li>Merging will reassign all visits, orders, and billing from the secondary record to the primary.</li>
          <li>The secondary patient record will be archived (not deleted).</li>
          <li>This action cannot be easily undone.</li>
        </ul>
      </div>

      {/* Confirmation Checkbox */}
      <div className="form-check merge-refined-confirm mt-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="mergeConfirmCheck"
          checked={confirmChecked || false}
          onChange={(e) => onConfirmCheckedChange && onConfirmCheckedChange(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="mergeConfirmCheck">
          I understand the consequences and want to proceed with the merge.
        </label>
      </div>
    </div>
  );
};

export default MergeSummaryPanel;

